export const addZeroToCodigo = _id => {
	const id = _id || 0;
	if (id.toString().length === 4) return `0${id}`;
	return id;
};
